import React from "react";
import Hero from "../components/Hero";
import Partners from "../components/Partners";
import Services from "../components/Services";
import Products from "../components/Products";
import Insights from "../components/Insights";
import Clients from "../components/Clients";
import Testimonials from "../components/Testimonials";

const HomeLiberia = () => {
  return (
    <>
    <div>
      <Hero />
    </div>
    <div>
      <Partners />
    </div>
    <div className="container services-sec">
      <div className="section-label">

      </div>
      <div>
        <Services />
      </div>
    </div>
    <div className="container products-sec">
      <div className="section-label">

      </div>
      <div>
        <Products />
      </div>
    </div>
    <div className="container insight-sec">
      <div className="section-label">

      </div>
      <div>
        <Insights />
      </div>
    </div>
    <div className="container client-sec">
      <div className="section-label">

      </div>
      <div>
        <Clients />
      </div>
    </div>
    <div className="container testimonial-sec">
      <div className="section-label">

      </div>
      <div>
        <Testimonials />
      </div>
    </div>
    </>
  );
};

export default HomeLiberia;
